import React from "react";
import { cn } from "../../../shared/lib/utils.js";
import { MOBILE_TABBAR_UI_CONFIG } from "../constants/mobile-tabbar-ui-config.js";
import { useMobileTabbar } from "../hooks/use-mobile-tabbar.js";
import { MobileTabbarItem } from "./mobile-tabbar-item.js";

/**
 * @param {{ variant?: "solid" | "floating" }} props
 */
export function MobileTabbar({ variant = "floating" }) {
  const { visible, tabs, activeKey, variant: resolvedVariant, isDrawerOpen, onTabPress } =
    useMobileTabbar(variant);

  if (!visible) {
    return null;
  }

  const surfaces =
    resolvedVariant === "solid"
      ? MOBILE_TABBAR_UI_CONFIG.surfaces.solid
      : MOBILE_TABBAR_UI_CONFIG.surfaces.floating;

  const isFloating = resolvedVariant === "floating";
  const floatingSurfaces = MOBILE_TABBAR_UI_CONFIG.surfaces.floating;

  return (
    <nav
      className={cn(
        surfaces.container,
        isFloating && isDrawerOpen && floatingSurfaces.containerHidden,
      )}
      aria-label="Navegação mobile"
    >
      <div className={surfaces.inner}>
        {tabs.map((tab) => (
          <MobileTabbarItem
            key={tab.key}
            tab={tab}
            isActive={activeKey === tab.key}
            surfaces={surfaces}
            onPress={onTabPress}
          />
        ))}
      </div>
    </nav>
  );
}

export default MobileTabbar;
